/* ▼▼▼ トッピング追加 ＆ 価格連動機能 (v7.5 - バッジ親の visually-hidden を確実に外す) ▼▼▼ */
(function() {

  /* ========== 金額フォーマット ========== */
  function formatPrice(cents, moneyFormat) {
    try {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, moneyFormat || '¥{{amount}}');
      }
      return '¥' + (cents / 100).toLocaleString('ja-JP');
    } catch (e) {
      console.error('Price formatting error:', e);
      return '¥' + (cents / 100).toLocaleString('ja-JP');
    }
  }

  /* ========== バッジ更新（属性ベース & 多数派生サポート） ========== */
  function applyCountToBadge(qty) {
    const q = Number(qty) || 0;

    // 1) data-cart-count（独自/安全フック）
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = q;
      showBadge(el, q);
    });

    // 2) Dawn/Horizon 系：<cart-count-bubble> / .cart-count-bubble
    document.querySelectorAll('cart-count-bubble, .cart-count-bubble').forEach(el => {
      try { el.setAttribute('count', String(q)); } catch(_) {}
      try { el.setAttribute('data-count', String(q)); } catch(_) {}
      try { el.setAttribute('data-cart-count-bubble-visible', q > 0 ? 'true' : 'false'); } catch(_) {}

      const t =
        el.querySelector('.count') ||
        el.querySelector('[data-count]') ||
        el.querySelector('span[aria-hidden="true"]') ||
        el.querySelector('span');
      if (t) t.textContent = q;

      showBadge(el, q);
    });

    // 3) 代表 ID：#cart-icon-bubble 配下
    document.querySelectorAll('#cart-icon-bubble, [id^="cart-icon-bubble"]').forEach(el => {
      const mark = el.querySelector('[data-count], .count, span');
      if (mark) mark.textContent = q;
      el.setAttribute('data-count', String(q));
      showBadge(el, q);
    });

    // 4) よくある独自実装
    document.querySelectorAll('[data-cart-items-count], [data-cart-badge], .header__cart-count').forEach(el => {
      el.textContent = q;
      el.setAttribute('data-cart-items-count', String(q));
      showBadge(el, q);
    });
  }

  // ● ここを強化：親の .cart-bubble からも確実に非表示クラス/属性を外す
  function showBadge(el, qty) {
    const visible = Number(qty) > 0;

    // 自分自身の hidden/aria-hidden/クラス
    toggleVisibilityFlags(el, visible);

    // 最寄りの cart-bubble ラッパー（あなたのテーマの外枠）
    const wrapper = el.closest('.cart-bubble');
    if (wrapper) {
      toggleVisibilityFlags(wrapper, visible);
      // Dawn/Horizonでは「visually-hidden」を使うのでこれも外す
      if (visible && wrapper.classList.contains('visually-hidden')) {
        wrapper.classList.remove('visually-hidden');
      }
    }

    // さらに親方向に .header-actions__cart-icon 等があれば、同様に表示側へ
    const cartIcon = el.closest('.header-actions__cart-icon, cart-icon');
    if (cartIcon) {
      toggleVisibilityFlags(cartIcon, visible);
    }
  }

  function toggleVisibilityFlags(node, visible) {
    if (!node) return;
    // hidden 属性と aria-hidden
    if (visible) {
      node.removeAttribute('hidden');
      node.setAttribute('aria-hidden', 'false');
      // display を明示復帰（テーマが style="display:none" を付けた場合に備える）
      if (node.style && (node.style.display === 'none')) node.style.display = '';
      if (node.style && (node.style.visibility === 'hidden')) node.style.visibility = '';
    } else {
      node.setAttribute('hidden', 'hidden');
      node.setAttribute('aria-hidden', 'true');
    }
    // よくあるクラス
    if (node.classList) {
      node.classList.toggle('hidden', !visible);
      node.classList.toggle('is-empty', !visible);
      node.classList.toggle('is-visible', visible);
      // visually-hidden は「非表示」の意味なので、見せる場合は外す
      if (visible && node.classList.contains('visually-hidden')) {
        node.classList.remove('visually-hidden');
      }
    }
  }

  // “置換に強い”再適用（あり追加後〜2秒間監視）
  let reapplyObserver = null;
  function armReapplyObserver(latestQty) {
    if (reapplyObserver) {
      try { reapplyObserver.disconnect(); } catch(_) {}
      reapplyObserver = null;
    }
    const deadline = Date.now() + 2000;
    reapplyObserver = new MutationObserver(() => {
      if (Date.now() > deadline) {
        reapplyObserver.disconnect();
        reapplyObserver = null;
        return;
      }
      applyCountToBadge(latestQty);
    });
    reapplyObserver.observe(document.body, { childList: true, subtree: true });
    applyCountToBadge(latestQty);
  }

  /* ========== /cart.js で取得 → バッジ同期 ========== */
  async function refreshCartAndBadge() {
    try {
      const res = await fetch(`${window.Shopify.routes.root}cart.js`, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(res.statusText);
      const cart = await res.json();
      const qty = typeof cart.item_count === 'number' ? cart.item_count : (cart.total_quantity || 0);

      applyCountToBadge(qty);
      armReapplyObserver(qty);

      // 互換イベント
      try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } })); } catch(_) {}
      try { window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } })); } catch(_) {}
      try { window.dispatchEvent(new CustomEvent('cart:count', { detail: { count: qty } })); } catch(_) {}

    } catch (e) {
      console.warn('Failed to refresh cart badge:', e);
    }
  }

  /* ========== 価格＆ボタン文言の更新 ========== */
  function updateDynamicPrices(formComponent) {
    if (!formComponent) return;
    const form = formComponent.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    const checkedTopping = form.querySelector('.topping-option__radio:checked');
    const addToCartButton = formComponent.querySelector('[name="add"]');
    const buttonTextElement = addToCartButton ? addToCartButton.querySelector('.add-to-cart-text__content') : null;

    const productDetails = formComponent.closest('.product-details');
    const priceElement = productDetails ? productDetails.querySelector('[data-product-price]') : null;

    if (!addToCartButton || !buttonTextElement) return;

    if (!addToCartButton.dataset.baseText) {
      addToCartButton.dataset.baseText = buttonTextElement.textContent.trim();
    }
    const baseText = addToCartButton.dataset.baseText;

    let mainPrice = 0;
    const variantIdInput = form.querySelector('input[name="id"]');
    const variantId = variantIdInput ? variantIdInput.value : null;

    try {
      const productDataElement = document.getElementById(`ProductJson-${formComponent.dataset.productId}`);
      if (productDataElement) {
        const productData = JSON.parse(productDataElement.textContent);
        const currentVariant = productData.variants.find(v => String(v.id) === String(variantId));
        if (currentVariant) mainPrice = currentVariant.price;
      }
    } catch (e) {
      console.error('Error parsing product JSON:', e);
    }

    let toppingPrice = 0;
    if (checkedTopping) {
      const raw = parseInt(checkedTopping.dataset.toppingPrice, 10);
      if (!isNaN(raw)) toppingPrice = raw * 100;
    }

    const totalPrice = mainPrice + toppingPrice;
    const formattedPrice = formatPrice(totalPrice, formComponent.dataset.moneyFormat);

    buttonTextElement.textContent = totalPrice > 0 ? `${baseText} - ${formattedPrice}` : baseText;

    if (priceElement) priceElement.textContent = formattedPrice;
  }

  /* ========== バリアント変更監視 ========== */
  function setupVariantChangeListener(formComponent) {
    const variantIdInput = formComponent.querySelector('input[name="id"]');
    if (!variantIdInput) return;
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'value') {
          updateDynamicPrices(formComponent);
        }
      }
    });
    observer.observe(variantIdInput, { attributes: true });
  }

  /* ========== 「あり」時は submit させず click をハイジャック ========== */
  function setupAddButtonHijack(formComponent) {
    const form = formComponent.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    const addBtn = formComponent.querySelector('[name="add"]');
    if (!addBtn) return;

    addBtn.addEventListener('click', async (ev) => {
      const toppingCheckbox = form.querySelector('input[data-topping-variant-id]:checked');

      if (toppingCheckbox) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        ev.stopPropagation();

        if (formComponent.dataset.toppingSubmitting === '1') return;
        formComponent.dataset.toppingSubmitting = '1';

        const prevDisabled = addBtn.disabled;
        addBtn.disabled = true;

        try {
          const formData = new FormData(form);
          const toppingVariantId = toppingCheckbox.dataset.toppingVariantId;
          const mainVariantId = formData.get('id');
          const mainQuantity = parseInt(formData.get('quantity') || '1', 10) || 1;

          const items = [
            {
              id: mainVariantId,
              quantity: mainQuantity,
              properties: {
                [toppingCheckbox.name.replace(/properties\[|\]/g, '')]: toppingCheckbox.value
              }
            },
            {
              id: toppingVariantId,
              quantity: mainQuantity
            }
          ];

          const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });

          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || `Error: ${res.statusText}`);
          }

          // バッジ可視化（親の visually-hidden も外す）
          await refreshCartAndBadge();

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }

        } catch (e) {
          console.error('トッピングの追加に失敗しました:', e);
        } finally {
          formComponent.dataset.toppingSubmitting = '0';
          addBtn.disabled = prevDisabled;
        }
      }
      // 「なし」は通常の submit に委ねる
    }, true);
  }

  /* ========== 念のための submit バックストップ ========== */
  function setupSubmitBackstop(formComponent) {
    const form = formComponent.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    form.addEventListener('submit', (event) => {
      const toppingCheckbox = form.querySelector('input[data-topping-variant-id]:checked');
      if (toppingCheckbox) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
      }
    }, true);
  }

  /* ========== 初期化 ========== */
  function initializeToppingFeature() {
    const productForms = document.querySelectorAll('product-form-component');

    productForms.forEach(formComponent => {
      const toppingRadios = formComponent.querySelectorAll('.topping-option__radio');

      if (toppingRadios.length > 0) {
        toppingRadios.forEach(radio => {
          radio.addEventListener('change', (e) => {
            e.stopPropagation();
            updateDynamicPrices(formComponent);
          });
        });
      }

      setupVariantChangeListener(formComponent);
      setupAddButtonHijack(formComponent);
      setupSubmitBackstop(formComponent);

      setTimeout(() => updateDynamicPrices(formComponent), 300);
    });
  }

  document.addEventListener('DOMContentLoaded', initializeToppingFeature);
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initializeToppingFeature);
  }

})();
